module.exports = __webpack_public_path__ + "static/media/sh-ta.54b91082.svg";